module.exports = __webpack_public_path__ + "img/s-logo.b86f8b01.png";